// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React from "react";
import "./common.css";

import { Breadcrumbs, Breadcrumb } from "./BreadCrumb";
import { LoggedInAs } from "./LoggedInAs";
import { School } from "../store/schema";
import { ErrorBoundary } from "./ErrorBoundary";

interface PageHeaderProps {
  crumbs: Breadcrumb[];
  school: School | null;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ crumbs, school }) => {
  return (
    <ErrorBoundary>
      <div>
        {crumbs.length > 0 && <Breadcrumbs crumbs={crumbs} />}
        <LoggedInAs />
        <div className="clear-both" />
        {school != null && <SchoolBanner school={school} />}
      </div>
    </ErrorBoundary>
  );
};

interface SchoolBannerProps {
  school: School;
}

const SchoolBanner: React.FC<SchoolBannerProps> = ({ school }) => {
  const primary = school.primaryColor || "rgb(255, 255, 255)";
  const accent = school.accentColor || primary;
  const bannerMain = {
    background: primary,
    color: accent,
  };
  const bannerAccent = {
    background: accent,
  };

  return (
    <div className="page-header">
      <div className="banner-accent" style={bannerAccent} />
      <div className="banner" style={bannerMain}>
        <h1>{school ? school.name : "(No school chosen yet)"}</h1>
      </div>
      <div className="banner-accent" style={bannerAccent} />
    </div>
  );
};
